import React, { useCallback, useEffect, useRef } from "react";

import Form, {
  ButtonItem,
  EmptyItem,
  GroupItem,
  SimpleItem,
} from "devextreme-react/form";
import { Label } from "devextreme-react/tree-list";
//--
import { run } from "effection";
//--
import isEqual from "react-fast-compare";
import { useTranslation } from "react-i18next";

import { useReverseRoute } from "@app/contexts";
import { ensureArray } from "@app/service/helpers";
import {
  selectCurrentEmail,
  selectHomeDataOfSelectedUser,
  upsertGroupMember,
  useAppDispatch,
  useAppSelector,
} from "@app/state";

import "./userdef.scss";

import type { Operation } from "effection";
import type { ButtonType } from "devextreme/common";

import type { IAdminGroupUser } from "@app/types";

export const UserDefinition = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const formRef = useRef<any>(null);
  const dataRef = useRef<any>(null);
  const { routeInit } = useReverseRoute("form/userdef");
  const theEmail = useAppSelector(selectCurrentEmail);
  const theData = useAppSelector((s) =>
    selectHomeDataOfSelectedUser(s, theEmail)
  );
  //eslint-disable-next-line require-yield
  function* eStartUpdate(): Operation<string> {
    if (formRef?.current) {
      formRef.current.instance().beginUpdate();
    }
    return "started";
  }
  //eslint-disable-next-line require-yield
  function* eEndUpdate(): Operation<string> {
    if (formRef?.current) {
      formRef.current.instance().endUpdate();
    }
    return "ended";
  }

  const eUpdateRecord = ({
    key,
    values,
  }: {
    key: { GROUP_EMAIL: string };
    values: IAdminGroupUser;
  }) =>
    function* (): Operation<boolean> {
      yield* eStartUpdate();
      // console.log("eUpdateRecord", key, values);
      yield* eEndUpdate();
      return true;
    };

  const eSaveRecord = () => {
    return function* (): Operation<boolean> {
      yield* eStartUpdate();
      dispatch(upsertGroupMember(dataRef.current));
      yield* eEndUpdate();
      return true;
    };
  };

  useEffect(() => {
    const eq = isEqual(dataRef.current, theData);
    if (!eq) {
      dataRef.current = theData;
      run(
        eUpdateRecord({
          key: { GROUP_EMAIL: theData.GROUPID_EMAIL },
          values: theData,
        })
      );
    }
    return () => {
      dataRef.current = null;
    };
  }, [JSON.stringify(theData)]);

  const formFieldDataChanged = useCallback((e: any) => {
    const { dataField, value } = e;
    const eq = isEqual(dataRef.current[dataField], value);
    if (!eq) {
      dataRef.current[dataField] = value;
      run(
        eUpdateRecord({
          key: { GROUP_EMAIL: theData.GROUPID_EMAIL },
          values: dataRef.current,
        })
      );
    }
  }, []);

  const buttonOptions = {
    text: t("Save"),
    width: 240,
    icon: "save",
    type: "default" as ButtonType,
    useSubmitBehavior: false,
    onClick: () => {
      run(eSaveRecord());
    },
  };

  const RoleItem = () => {
    const arr = ensureArray(dataRef.current._roles);
    return (
      <div className="role-badges">
        {arr.map((r, index) => (
          <span key={index} className="role-badge">
            {r}
          </span>
        ))}
      </div>
    );
  };
  const EmailItem = () => {
    return <div>{dataRef.current?.OUSER_EMAIL}</div>;
  };
  const VerifiedItem = () => {
    return <div>{dataRef.current?._verified ? "DA" : "NU"} </div>;
  };
  //   GROUPID_EMAIL: string;
  //   SEED: string;
  //   PERSEED: string;
  //   GROUPID: number;
  //   AMAXAVO: number;
  //   OUSER_NAME: string;
  //   OUSER_EMAIL: string;
  //   OUSER_RIGHTS: string;
  //   OUSER_IS_ACTIVE: number;
  //   OUSER_STATUS: string;
  //   OUSER_STATUSOP: Date;
  return (
    <div ref={routeInit}>
      <form>
        <Form
          elementAttr={{ cssClass: "admin-user-form" }}
          ref={formRef}
          formData={theData}
          labelLocation="top"
          labelMode="outside"
          onFieldDataChanged={formFieldDataChanged}
          //   colCount={2}
        >
          <GroupItem colCount={8} caption={t("fusion_jgap_userdef")}>
            <SimpleItem dataField="OUSER_EMAIL" render={EmailItem} colSpan={4}>
              <Label text="Cont" />
            </SimpleItem>
            <SimpleItem dataField="_verified" render={VerifiedItem} colSpan={4}>
              <Label text="Email verificat" />
            </SimpleItem>

            <SimpleItem
              dataField="OUSER_NAME"
              editorType="dxTextBox"
              colSpan={4}
            >
              <Label text={t("Nume")} />
            </SimpleItem>
            <SimpleItem render={RoleItem} colSpan={4}>
              <Label text="Rol" />
            </SimpleItem>

            <EmptyItem colSpan={2} />
            <ButtonItem buttonOptions={buttonOptions} colSpan={2} />
          </GroupItem>
          {/* <GroupItem colCount={2} caption="Fb/MOA Auth (todo)"></GroupItem> */}
        </Form>
      </form>
    </div>
  );
};
